import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { HelpCircle } from "lucide-react";

const FAQS = [
  {
    q: "How long does a typical 2 BHK repaint take?",
    a: "A standard 2 BHK (around 900–1,100 sq.ft) typically takes 3–5 working days — including primer and 2 coats of premium emulsion. Designer accent walls may add 1–2 days.",
  },
  {
    q: "Are the rates inclusive of paint and labour?",
    a: "Yes. All our rates are all-inclusive — labour, branded paint (Asian Paints / Berger / Dulux), primer, sandpaper, drop cloths and clean-up. There are no hidden charges for a standard repaint.",
  },
  {
    q: "Do you move furniture and cover the house?",
    a: "Our crew covers all furniture with plastic sheets, tapes switch boards, and protects flooring. For heavy furniture we shift it to the centre of the room and cover thoroughly — no need for you to move anything yourself.",
  },
  {
    q: "What paint brands do you work with?",
    a: "We use only original stock from Asian Paints, Berger, Dulux, Nippon and Indigo. We recommend Royale / Imperial / Weathershield ranges for best durability and finish.",
  },
  {
    q: "Is there a warranty on the repainting?",
    a: "Yes — our finish carries a 1-year craftsmanship warranty on interior repaints and up to 5-year durability on exterior weather-proof repaints (varies by paint range).",
  },
  {
    q: "How do I get an accurate quote?",
    a: "Share a few details via the form, WhatsApp us, or call +91 70190 56581 — we’ll schedule a free site visit. The final quote is confirmed after the on-site inspection and is itemised, with zero hidden costs.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" data-testid="faq-section" className="py-20 md:py-28">
      <div className="max-w-5xl mx-auto px-5 md:px-10">
        <div className="text-center max-w-2xl mx-auto">
          <div className="inline-flex items-center gap-1.5 rounded-full bg-orange-50 px-3 py-1 text-[11px] font-bold tracking-widest uppercase text-orange-700">
            <HelpCircle className="h-3.5 w-3.5" /> FAQ
          </div>
          <h2 className="mt-4 font-display font-black text-3xl sm:text-4xl lg:text-5xl text-ink">
            Questions? We&apos;ve got answers.
          </h2>
          <p className="mt-4 text-ink-2">
            Everything you want to know before you book a painting job with us.
          </p>
        </div>

        <div className="mt-10 rounded-3xl bg-white hairline shadow-soft p-3 md:p-5">
          <Accordion type="single" collapsible className="w-full">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={f.q}
                value={`item-${i}`}
                className="border-b border-slate-100 last:border-b-0 px-3 md:px-5"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="text-left font-display font-bold text-ink hover:no-underline py-5 text-base md:text-[17px]">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-ink-2 pb-5 pr-5 text-sm md:text-[15px] leading-relaxed">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
